(function () {
  if (window.initProductCardFPS) return;

  function readJSON(el) {
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function getGameSlug(name) {
    return String(name || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function normRes(res) {
    const r = String(res || "").toLowerCase();
    if (r.includes("2160") || r.includes("4k")) return "4k";
    if (r.includes("1440")) return "1440p";
    return "1080p";
  }

  function normQ(q) {
    const s = String(q || "").toLowerCase();
    if (s.startsWith("low")) return "low";
    if (s.startsWith("med")) return "medium";
    if (s.startsWith("high")) return "high";
    return "ultra";
  }

  function normUpscale(u) {
    const s = String(u || "").toLowerCase();
    if (s.includes("fsr")) return "fsr";
    if (s.includes("dlss")) return "dlss";
    return "native";
  }

  function buildSimplePerf(perfList) {
    const perf = {
      "1080p": { low: {}, medium: {}, high: {}, ultra: {} },
      "1440p": { low: {}, medium: {}, high: {}, ultra: {} },
      "4k": { low: {}, medium: {}, high: {}, ultra: {} }
    };

    (Array.isArray(perfList) ? perfList : []).forEach((game) => {
      const gameKey = getGameSlug(game?.name);
      if (!gameKey) return;

      (Array.isArray(game?.performance_rows) ? game.performance_rows : []).forEach((row) => {
        const res = normRes(row?.resolution);
        const quality = normQ(row?.quality);
        const upscale = normUpscale(row?.upscale || row?.upscaling || row?.upscaler);
        const fps = Number(row?.fps);

        if (!Number.isFinite(fps)) return;

        perf[res] ||= { low: {}, medium: {}, high: {}, ultra: {} };
        perf[res][quality] ||= {};
        perf[res][quality][gameKey] ||= {};
        perf[res][quality][gameKey][upscale] = fps;
      });
    });

    return perf;
  }

  function getSimpleFPS(perf, gameName, resolution, quality) {
    const gameKey = getGameSlug(gameName);
    const q = normQ(quality);
    const r = normRes(resolution);

    const exact = perf?.[r]?.[q]?.[gameKey]?.native;
    if (typeof exact === "number") return exact;

    const anyUpscale =
      perf?.[r]?.[q]?.[gameKey]?.dlss ??
      perf?.[r]?.[q]?.[gameKey]?.fsr;

    if (typeof anyUpscale === "number") return anyUpscale;

    return null;
  }

  function getVariantContext(card, pc) {
    const selection = {
      CPU: pc?.base_specs?.cpu || "",
      GPU: pc?.base_specs?.gpu || "",
      RAM: pc?.base_specs?.ram || ""
    };

    let variantId = null;

    const form =
      card.querySelector('form[action*="/cart/add"]') ||
      card.querySelector('product-form form') ||
      card.querySelector('form');

    if (!form) {
      return { variantId, selection };
    }

    const idInput =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]');

    if (idInput && idInput.value) {
      variantId = String(idInput.value);
    }

    const optionInputs = Array.from(
      form.querySelectorAll('select[name^="options["], input[type="radio"][name^="options["]:checked')
    );

    optionInputs.forEach((input) => {
      const match = String(input.name || "").match(/^options\[(.+)\]$/);
      if (!match) return;

      const optionName = String(match[1] || "").toLowerCase().trim();
      const value = String(input.value || "").trim();
      if (!value) return;

      if (optionName.includes("cpu") || optionName.includes("processor")) {
        selection.CPU = value;
      } else if (
        optionName.includes("gpu") ||
        optionName.includes("graphics") ||
        optionName.includes("video")
      ) {
        selection.GPU = value;
      } else if (
        optionName.includes("ram") ||
        optionName.includes("memory")
      ) {
        selection.RAM = value;
      }
    });

    return { variantId, selection };
  }

  function getComputedFPSFactory(pc, heroBaselinePerf, variantId, selection) {
    const ownPerf = buildSimplePerf(pc?.perf_list || []);

    return function getComputedFPS(gameName, resolution, quality) {
      let fps = null;

      if (
        window.GMFpsCore &&
        typeof window.GMFpsCore.computeGameFPS === "function" &&
        heroBaselinePerf
      ) {
        fps = window.GMFpsCore.computeGameFPS({
          pc,
          heroBaselinePerf,
          gameName: getGameSlug(gameName),
          resolution: normRes(resolution),
          quality: normQ(quality),
          variantId: variantId,
          selection: selection
        });
      }

      if (typeof fps === "number" && Number.isFinite(fps)) {
        return fps;
      }

      return getSimpleFPS(ownPerf, gameName, resolution, quality);
    };
  }

  function renderPopover(perfPopover, getComputedFPS) {
    if (!perfPopover) return;

    const popoverGames = [
      "Fortnite",
      "Valorant",
      "Call of Duty: Warzone",
      "Cyberpunk 2077",
      "Black Myth: Wukong",
      "Baldur's Gate 3"
    ];

    let rowsHtml = `
      <div class="gm-cyber-card__perf-title">
        <span>Games/FPS</span>
        <span style="text-align:right;">1080P</span>
        <span style="text-align:right;">1440P</span>
      </div>
    `;

    let shown = 0;

    popoverGames.forEach((game) => {
      const fps1080 = getComputedFPS(game, "1080p", "low");
      const fps1440 = getComputedFPS(game, "1440p", "low");

      if (typeof fps1080 === "number" || typeof fps1440 === "number") {
        shown += 1;
        rowsHtml += `
          <div class="gm-cyber-card__perf-row">
            <span class="gm-cyber-card__perf-game">${game}</span>
            <span class="gm-cyber-card__perf-fps">${typeof fps1080 === "number" ? fps1080 : "–"}</span>
            <span class="gm-cyber-card__perf-fps">${typeof fps1440 === "number" ? fps1440 : "–"}</span>
          </div>
        `;
      }
    });

    if (shown === 0) {
      perfPopover.innerHTML = `
        <div class="gm-cyber-card__perf-title">
          <span>Games/FPS</span>
          <span style="text-align:right;">1080P</span>
          <span style="text-align:right;">1440P</span>
        </div>
        <div class="gm-cyber-card__perf-empty">No performance data available.</div>
      `;
    } else {
      rowsHtml += `<div class="gm-cyber-card__perf-footer">+ more games on product page →</div>`;
      perfPopover.innerHTML = rowsHtml;
    }
  }

  async function initSingleProductCardFPS(card) {
    if (!card) return;

    const fpsValueEl = card.querySelector('[data-role="fpsValue"]');
    const perfPopover = card.querySelector('[data-role="perfPopover"]');
    const pcJsonEl = card.querySelector('[data-role="pc-card-data"]');
    const heroJsonEl = card.querySelector('[data-role="hero-card-data"]');

    if (!fpsValueEl || !pcJsonEl || !heroJsonEl) return;

    try {
      const pc = readJSON(pcJsonEl);
      const hero = readJSON(heroJsonEl);

      if (!pc || !hero) {
        fpsValueEl.textContent = "FPS N/A";
        return;
      }

      await window.GMFpsCore.loadProfiles({
        gpu: "/assets/fps-gpu-multipliers.json",
        cpu: "/assets/fps-cpu-multipliers.json",
        ram: "/assets/fps-ram-multipliers.json",
        ram_capacity: "/assets/fps-ram-capacity-multipliers.json",
        ram_channel: "/assets/fps-ram-multipliers.json",
        ram_generation: "/assets/fps-ram-generation-multipliers.json"
      });

      const heroBaselinePerf = window.GMFpsCore.buildPerfForPC(hero.perf_list, hero);
      const { variantId, selection } = getVariantContext(card, pc);
      const getComputedFPS = getComputedFPSFactory(pc, heroBaselinePerf, variantId, selection);

      const headlineGames = [
        "Fortnite",
        "Valorant",
        "Call of Duty: Warzone"
      ];

      let headlineFPS = 0;

      headlineGames.forEach((game) => {
        const fps = getComputedFPS(game, "1080p", "low");
        if (typeof fps === "number" && fps > headlineFPS) {
          headlineFPS = fps;
        }
      });

      fpsValueEl.innerHTML = headlineFPS > 0
        ? `<span class="gm-fps-prefix">Up to</span> ${headlineFPS} FPS`
        : "FPS N/A";

      renderPopover(perfPopover, getComputedFPS);
    } catch (e) {
      console.error("FPS init failed:", e);
      fpsValueEl.textContent = "FPS N/A";
    }
  }

  window.initProductCardFPS = async function (scope) {
    const root = scope || document;
    let cards = [];

    if (root.matches && root.matches("product-card")) {
      cards = [root];
    } else {
      cards = Array.from(root.querySelectorAll("product-card"));
    }

    if (!cards.length) return;

    await Promise.all(cards.map((card) => initSingleProductCardFPS(card)));
  };

  function runProductCardFPSInit() {
    if (window.initProductCardFPS) {
      window.initProductCardFPS(document);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runProductCardFPSInit);
  } else {
    runProductCardFPSInit();
  }

  document.addEventListener("change", function (e) {
    const card = e.target.closest && e.target.closest("product-card");
    if (!card || !window.initProductCardFPS) return;
    window.initProductCardFPS(card);
  });
})();